import { useUserLocale } from '@futrli/localisation';
import { useSxpContext } from '@futrli/predict';

export const UserLocaleManager = () => {
  const { sceneData } = useSxpContext();
  const sceneUserLocale = sceneData?.User?.Locale;

  useUserLocale(sceneUserLocale);

  return null;
};
